import { useEffect, useState } from 'react';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { useStoreUnitActions } from 'src/redux/helpers';
import { useParams } from 'react-router-dom';
import { API_PUT_OMNIVERSE_APP } from '../../constants';
import solutionsStore, {
  useCurrentSolutionName,
  useSolutionDetails,
} from '../../redux';
import SolutionOmniverseEditModal from './SolutionOmniverseEditModal';
import { SolutionOmniverseApp } from '../../types';

type Props = {
  item: SolutionOmniverseApp;
  sitesId?: string;
  id?: string;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionOmniverseEditContainer({
  item,
  sitesId,
  id,
  open,
  onClose,
}: Props) {
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();
  const { showAlert } = useAlert();
  const actions = useStoreUnitActions(solutionsStore);
  const [solutionDetails] = useSolutionDetails();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generateApiPath(API_PUT_OMNIVERSE_APP, {
          solutionId,
          siteId: sitesId,
          appId: item?.id,
          twinId: id,
        }),
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Info,
        title: 'App Updated',
        text: `${params?.title} has been updated successfully`,
      });
      onClose(null, ModalCloseReason.completeAction);
      actions.omniverseApp({
        solutionId,
        siteId: sitesId,
        appId: item?.id,
        twinId: id,
      });
    }
  );

  return (
    <SolutionOmniverseEditModal
      item={item}
      title={'Edit Application'}
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      confirmBtnText={'Save'}
      loading={loading}
    />
  );
}

export default SolutionOmniverseEditContainer;
